import ApiHandler from './ApiHandler';

export default {
    getFixtures: ({ teamId }) =>
        ApiHandler.get(`/matches/fixtures?teamId=${teamId}`)
};
